import React from 'react';
import Navigation from '../../components/navigation';
import Footer from '../../components/footer';
import Logo from '@public/images/logo.png';
import Poster from '@public/images/poster.jpg';
import HomeCode from '@public/images/home-code.png';

function App() {
  return (
    <div className="app">
      <Navigation
        logo={Logo}
        active={0}
        list={[
          {
            name: '首页',
            path: './index.html',
          },
          {
            name: '公司介绍',
            path: './jquery.html',
          },
          {
            name: '招聘职位',
            path: './job.html',
          },
          {
            name: '企业官网',
            path: 'https://www.aia.com.cn/zh-cn/index.html',
          },
        ]}
      />
      <div className="video">
        <video controls poster={Poster} src="https://1500000890.vod2.myqcloud.com/6c9793f9vodcq1500000890/cc678213243791580119372826/5ajFTo5RJS0A.mp4" />
        <div className="qa-code"><img src={HomeCode} alt="" /></div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
